import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
console.log(document,window);
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/choose'
  },
  {
    path: '/choose',
    name: 'Choose',
    component: () => import('@/views/choose.vue')
  },
  {
    path: '/codeSearch',
    name: 'CodeSearch',
    component: () => import('@/views/codeSearch.vue')
  },
  {
    path: '/selectType',
    name: 'SelectType',
    component: () => import('@/views/selectType.vue')
  },
  {
    path: '/matterTip',
    name: 'MatterTip',
    component: () => import('@/views/matterTip.vue')
  },
  {
    path: '/howApply',
    name: 'HowApply',
    component: () => import('@/views/howApply.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register.vue')
  },
  {
    path: '/searchLogin',
    name: 'searchLogin',
    component: () => import('@/views/searchLogin.vue')
  },

  {
    path: '/caselist',
    name: 'caselist',
    component: () => import('@/views/caseList.vue')
  },
  {
    path: '/newCase',
    name: 'NewCase',
    component: () => import('@/views/NewCase/newCase.vue')
  },
  {
    path: '/oldNewCase',
    name: 'oldNewCase',
    component: () => import('@/views/oldNewCase/newCase.vue')
  },
  {
    path: '/detailCase',
    name: 'DetailCase',
    component: () => import('@/views/DetailCase/detailCase.vue')
  },
  {
    path: '/oldDetailCase',
    name: 'oldDetailCase',
    component: () => import('@/views/oldDetailCase/detailCase.vue')
  },
  // 文书公开列表
  {
    path: '/documentsList',
    name: 'DocumentsList',
    component: () => import('@/views/DocumentsPublicly/documentsList.vue')
  },
  {
    path: '/documentsDetail',
    name: 'DocumentsDetail',
    component: () => import('@/views/DocumentsPublicly/documentsDetail.vue')
  },
  // 阅卷相关页面
  {
    path: '/reviewList',
    name: 'ReviewList',
    component: () => import('@/views/reviewList.vue')
  },
  {
    path: '/filePreview',
    name: 'FilePreview',
    component: () => import('@/views/filePreview.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue')
  },
  // 移动端 页面
  {
    path: '/m-codeSearch',
     name: 'MCodeSearch',
    component: () => import('@/views/mobile/codeSearch.vue')
  },
  {
    path: '/m-matterTip',
     name: 'MMatterTip',
    component: () => import('@/views/mobile/matterTip.vue')
  },
  {
    path: '/m-howApply',
     name: 'MHowApply',
    component: () => import('@/views/mobile/howApply.vue')
  },
  {
    path: '/m-register',
     name: 'MRegister',
    component: () => import('@/views/mobile/register.vue')
  },
  {
    path: '/m-login',
     name: 'MLogin',
    component: () => import('@/views/mobile/login.vue')
  },
  {
    path: '/m-auth',
     name: 'MAuth',
    component: () => import('@/views/mobile/auth.vue')
  },
  {
    path: '/m-selectType',
    name: 'MSelectType',
    component: () => import('@/views/mobile/selectType.vue')
  },
  {
    path: '/m-searchLogin',
     name: 'MSearchLogin',
    component: () => import('@/views/mobile/searchLogin.vue')
  },

  {
    path: '/m-caselist',
     name: 'Mcaselist',
    component: () => import('@/views/mobile/caseList.vue')
  },
  {
    path: '/m-newCase',
     name: 'MNewCase',
    component: () => import('@/views/mobile/NewCase/newCase.vue')
  },
  {
    path: '/m-oldNewCase',
     name: 'MoldNewCase',
    component: () => import('@/views/mobile/oldNewCase/newCase.vue')
  },
  {
    path: '/m-detailCase',
     name: 'MDetailCase',
    component: () => import('@/views/mobile/DetailCase/detailCase.vue')
  },
  {
    path: '/m-oldDetailCase',
     name: 'MoldDetailCase',
    component: () => import('@/views/mobile/oldDetailCase/detailCase.vue')
  },
  {
    path: '/m-reviewList',
    name: 'MReviewList',
    component: () => import('@/views/mobile/reviewList.vue')
  },
  {
    path: '/m-filePreview',
    name: 'MFilePreview',
    component: () => import('@/views/mobile/filePreview.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

// 路由白名单：未登录时允许访问的页面
const whiteList = ['/choose', '/selectType', '/codeSearch', '/documentsList', '/login', '/m-choose', '/m-selectType', '/m-codeSearch', '/m-documentsList', '/m-login', '/m-auth', '/m-register']

// 路由拦截
router.beforeEach((to, from, next) => {
  // 初始化登录状态（从 localStorage 读取）
  store.dispatch('initLoginStatus')
  
  // 获取登录状态
  const isLogin = store.state.user.isLogin
  
  // 如果已登录，允许访问所有页面
  if (isLogin) {
    next()
    return
  }
  
  // 如果未登录，检查是否在白名单中
  if (whiteList.includes(to.path)) {
    next()
  } else {
    // 未登录且不在白名单中，重定向到 codeSearch 页面
    next({
      path: '/codeSearch',
      query: { redirect: to.fullPath } // 保存原始路径，登录后可以跳转回来
    })
  }
})

export default router
